"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Pill = _interopRequireDefault(require("../Pill"));

require("./TypeAheadInput.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* eslint-disable react/jsx-curly-newline */

/* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role */

/* eslint-disable react/prop-types */
var TypeAheadInput = function TypeAheadInput(props) {
  var customMaxHeight = props.customMaxHeight,
      handleDelete = props.handleDelete,
      handleSelectItem = props.handleSelectItem,
      inputThreshold = props.inputThreshold,
      keyDown = props.keyDown,
      onChange = props.onChange,
      placeholder = props.placeholder,
      possibilities = props.possibilities,
      propertyID = props.propertyID,
      propertyName = props.propertyName,
      showTypeAhead = props.showTypeAhead,
      selectedItem = props.selectedItem,
      value = props.value; // eslint-disable-next-line react/prop-types

  var found = possibilities.filter(function (p) {
    if (p[propertyName] && // eslint-disable-next-line react/prop-types
    p[propertyName].toLowerCase().indexOf(value.toLowerCase()) > -1) return true;
    return false;
  });
  var isThresholdMore = value.length < inputThreshold;
  var isPossibilitiesNotEmpty = possibilities.length === 0;

  var fuzzyMe = function fuzzyMe(term, query) {
    var score = 0;
    var termLength = term.length;
    var queryLength = query.length;
    var highlighting = '';
    var ti = 0; // -1 would not work as this would break the calculations of bonus
    // points for subsequent character matches. Something like
    // Number.MIN_VALUE would be more appropriate, but unfortunately
    // Number.MIN_VALUE + 1 equals 1...

    var previousMatchingCharacter = -2;

    for (var qi = 0; qi < queryLength && ti < termLength; qi += 1) {
      var qc = query.charAt(qi);
      var lowerQc = qc.toLowerCase();

      for (; ti < termLength; ti += 1) {
        // TODO: need to fix this it's not correct
        var tc = term.charAt(ti);

        if (lowerQc === tc.toLowerCase()) {
          score += 1;

          if (previousMatchingCharacter + 1 === ti) {
            score += 2;
          }

          highlighting += "<span class='fw700'>".concat(tc, "</span>");
          previousMatchingCharacter = ti;
          ti += 1;
          break;
        } else {
          highlighting += tc;
        }
      }
    }

    highlighting += term.substring(ti, term.length);
    return {
      score: score,
      term: term,
      query: query,
      highlightedTerm: highlighting
    };
  };

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, selectedItem ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "fakeInput"
  }, /*#__PURE__*/_react["default"].createElement(_Pill["default"], {
    textClasses: "interff m0 ml12 mlr12 lh1 fz12",
    padding: "4px",
    "delete": handleDelete
  }, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, selectedItem.displayName))) : /*#__PURE__*/_react["default"].createElement("input", {
    type: "text",
    onChange: onChange,
    value: value,
    onKeyDown: keyDown,
    placeholder: placeholder || ''
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "t23 w100% bgc-white ".concat(customMaxHeight || 'mah200', " oys bd1-s-lightgray z99 ").concat(!showTypeAhead || isThresholdMore ? 'dn' : 'db')
  }, found.length > 0 ? /*#__PURE__*/_react["default"].createElement("ul", {
    className: "lsn p0 ".concat(value.length >= inputThreshold && showTypeAhead ? 'db' : 'dn')
  }, value.length >= inputThreshold && possibilities.length > 0 ? possibilities.map(function (p) {
    // TODO: implement highlighting of word, this gets us most of the way there.
    var fuzzy = fuzzyMe(p[propertyName], value);
    if (p[propertyName] && p[propertyName].toLowerCase().indexOf(value.toLowerCase()) > -1) return /*#__PURE__*/_react["default"].createElement("li", {
      role: "button",
      tabIndex: 0,
      onKeyDown: function onKeyDown(e) {
        return null;
      },
      onClick: function onClick() {
        return handleSelectItem(p[propertyID]);
      },
      className: "p10 curp",
      key: propertyID ? p[propertyID] : p[propertyName]
    }, /*#__PURE__*/_react["default"].createElement("p", {
      className: "fz15 c-black interff m0" // eslint-disable-next-line react/no-danger
      ,
      dangerouslySetInnerHTML: {
        __html: fuzzy.highlightedTerm || p[propertyName]
      }
    }));
    return null;
  }) : null) : /*#__PURE__*/_react["default"].createElement("p", {
    className: "fz15 c-black interff"
  }, isPossibilitiesNotEmpty ? 'No options available for this zone.' : 'No results found.')));
};

TypeAheadInput.defaultProps = {
  inputThreshold: 3
};
TypeAheadInput.propTypes = {
  inputThreshold: _propTypes["default"].number
};
var _default = TypeAheadInput;
exports["default"] = _default;